import { PF } from '@app/pages/Warehouses/WarehouseOperations/data';
import {
  useWarehouseOperations,
  useWarehouseOperationsEffects,
} from '@app/pages/Warehouses/WarehouseOperations/hooks';
import { Filters } from '@app/pages/Warehouses/WarehouseOperations/ui/Filters';
import { OperationsTable } from '@app/pages/Warehouses/WarehouseOperations/ui/OperationsTable';
import { FiltersAccordion } from '@app/shared/components';

import type { FC } from 'react';

import '@pages/Warehouses/WarehouseOperations/styles/WarehouseOperations.scss';

export const WarehouseOperations: FC = () => {
  const {
    isFetching,
    isPageLoading,
    disabledFilters,
    warehousesOptions,
    operationTypesOptions,
    productsOptions,
    filtersListsHandler,
    unsavedFilters,
    onFilterChange,
    onChangeSearchTerm,
    skipFilters,
    onSearch,
    onPaginate,
    pagination,
    searchProductOperationsHandler,
    tableData,
    columns,
  } = useWarehouseOperations();

  useWarehouseOperationsEffects({
    filtersListsHandler,
    searchProductOperationsHandler,
  });

  return (
    <div className={`${PF}_container`}>
      <div className={`${PF}_filters-section`}>
        <FiltersAccordion>
          <Filters
            warehousesOptions={warehousesOptions}
            operationTypesOptions={operationTypesOptions}
            productsOptions={productsOptions}
            disabled={disabledFilters}
            values={unsavedFilters}
            onFilterChange={onFilterChange}
            onChangeSearchTerm={onChangeSearchTerm}
            skipFilters={skipFilters}
            onSearch={onSearch}
          />
        </FiltersAccordion>
      </div>

      <div className={`${PF}_table-section`}>
        <OperationsTable
          columns={columns}
          data={tableData}
          isFetching={isFetching}
          isPageLoading={isPageLoading}
          onPaginate={onPaginate}
          pagination={pagination}
        />
      </div>
    </div>
  );
};
